<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('all_pages')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('Loyalty', 'reward', true)"
                          @click="openLoyaltyRewardModal()"
                          v-if="$can('add_crm')"
      />
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('manage', 'brands', true)"
                          @click="openBrandsModal()"
                          v-if="$can('add_crm')"
      />
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('page', 'header', true)"
                          @click="openHeaderModal()"
                          v-if="$can('add_crm')"
      />
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('add', 'page', true)"
                          @click="openModal()"
                          v-if="$can('add_crm')"
      />
    </app-page-top-section>

    <app-table
        id="crm-table"
        :options="options"
        :card-view="false"
        @reload="reloadCRMTable"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <app-crm-create-edit-modal
        v-if="isLocationCreateOpenModalActive || isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />

    <app-page-loyalty-reward-create-modal
        v-if="isLocationCreateOpenModalActive || isLoyaltyRewardModalActive"
        v-model="isLoyaltyRewardModalActive"
        :selected-url="selectedUrl"
        @close="isLoyaltyRewardModalActive = false"
    />

    <app-page-brands-create-modal
        v-if="isLocationCreateOpenModalActive || isBrandModalActive"
        v-model="isBrandModalActive"
        :selected-url="selectedUrl"
        @close="isBrandModalActive = false"
    />

    <app-page-header-create-modal
        v-if="isLocationCreateOpenModalActive || isHeaderModalActive"
        v-model="isHeaderModalActive"
        :selected-url="selectedUrl"
        @close="isHeaderModalActive = false"
    />
    <!--        :subPackage="subscriptionPackage"-->

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('crm-table')"
        @cancelled="cancelled"
    />

  </div>
</template>

<script>
// import PackageCreateEditModal from "./PackageCreateEditModal";

import {CRM_HOME, GET_CRM_HEADER, GET_CRM_BRANDS, CRM_LOYALTY_REWARD} from "../../../Config/ApiUrl";
import CRMCreateEditModal from "../Crm/CRMCreateEditModal";
import CRMMixin from "../../Mixins/CRMMixin";
export default {
  components: {CRMCreateEditModal},
  mixins: [CRMMixin],
  data() {
    return {
      isModalActive: false,
      isHeaderModalActive: false,
      isBrandModalActive: false,
      isLoyaltyRewardModalActive: false,
      selectedUrl: '',
      isLocationCreateOpenModalActive: false,
      subscriptionPackage: [],
      GET_CRM_BRANDS,
    }
  },
  methods: {
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
    openLoyaltyRewardModal() {
      this.isLoyaltyRewardModalActive = true;
      this.selectedUrl = CRM_LOYALTY_REWARD;
    },
    openBrandsModal() {
      this.isBrandModalActive = true;
      this.selectedUrl = GET_CRM_BRANDS;
    },
    openHeaderModal() {
      this.isHeaderModalActive = true;
      this.selectedUrl = GET_CRM_HEADER;
    },
    triggerActions(row, action, active) {
      this.subscriptionPackage = row;
      if (action.title === this.$t('edit')) {
        this.selectedUrl = `${CRM_HOME}/${row.id}`;
        this.isModalActive = true;
      }
      else {
        this.getAction(row, action, active)
      }
      // this.getAction(row, action, active)

    },
  }
}
</script>
